import React, { Component } from "react";
import FormComponent from "../../Form/FormComponent";
import { addSite } from "./SiteConfig";
import {
  addSiteQuery,
  getSiteEditData,
  siteCountryData,
  siteCountry,
  siteEmailQuery,
  siteStateData,
  siteCityData,
} from "./SiteQuery";
import { mutationQueries } from "../../MutationMethod";
import { fetchMethod, debounce } from "../../FetchMethod";
import {
  ListItem,
  ListItemText,
  List,
  Card,
  IconButton,
  Checkbox,
  Grid,
  Chip,
} from "@material-ui/core";
import "./siteForm.css";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import { FadeLoader } from "react-spinners";
import gql from "graphql-tag";
import SnackBarComponent from "../../SnackBar/SnackBar";
class EditSiteForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      preliminaryLeftTo: [],
      preliminaryRightTo: [],
      checkedPreliminaryRightTo: [],
      preliminaryLeftCC: [],
      preliminaryRightCC: [],
      checkedPreliminaryRightCC: [],
      treatmentLeftTo: [],
      treatmentRightTo: [],
      checkedTreatmentRightTo: [],
      treatmentLeftCC: [],
      treatmentRightCC: [],
      checkedTreatmentRightCC: [],
      editableData: undefined,
      CountryData: [],
      StateData: [],
      CityData: [],
      Userdata: undefined,
      loading: true,
      open: false,
      severity: "",
      alertmsg: "",
      saveButtonDisabled: false,
    };
  }
  UNSAFE_componentWillMount() {
    return this.props.location.state
      ? this.getSiteFormData()
      : this.props.history.push("/sites");
  }
  getSiteFormData = () => {
    fetchMethod(getSiteEditData(this.props.location.state.id))
      .then((res) => res.json())
      .then((res) => {
        if (res.data) {
          let preliminaryLeftTo = [];
          let preliminaryLeftCC = [];
          let treatmentLeftTo = [];
          let treatmentLeftCC = [];
          let data = res.data.allSites.Sites[0];
          data.PaSiteMap.Siteemails.map((item) => {
            return item.pasiteuserrel.Userdata.map((id) => {
              if (item.type === "PA" && item.toorcc === "TO") {
                id["siteemail"] = item.id;
                return preliminaryLeftTo.push(id);
              } else if (item.type === "PA" && item.toorcc === "CC") {
                id["siteemail"] = item.id;
                return preliminaryLeftCC.push(id);
              } else if (item.type === "TREATMENT" && item.toorcc === "TO") {
                id["siteemail"] = item.id;
                return treatmentLeftTo.push(id);
              } else {
                id["siteemail"] = item.id;
                return treatmentLeftCC.push(id);
              }
            });
          });
          data["countryid"] = data.sitecountryrel.Countries[0];
          data["stateid"] = data.sitestaterel.States[0];
          data["cityid"] = data.sitecityrel.Cities[0];
          this.setState(
            {
              editableData: data,
              preliminaryLeftTo,
              preliminaryLeftCC,
              treatmentLeftTo,
              treatmentLeftCC,
            },
            this.getDropDowndata
          );
        }
      })
      .catch((e) => console.log(e));
  };

  getDropDowndata() {
    let {
      preliminaryLeftTo,
      preliminaryLeftCC,
      treatmentLeftTo,
      treatmentLeftCC,
    } = this.state;
    fetchMethod(siteCountryData)
      .then((res) => res.json())
      .then((res) => {
        if (res.data) {
          let data = res.data.allUserdata.Userdata;
          let preliminaryRightTo = data.filter(
            ({ id: id1 }) =>
              !preliminaryLeftTo.some(({ id: id2 }) => id2 === id1)
          );
          let preliminaryRightCC = data.filter(
            ({ id: id1 }) =>
              !preliminaryLeftCC.some(({ id: id2 }) => id2 === id1)
          );
          let treatmentRightTo = data.filter(
            ({ id: id1 }) => !treatmentLeftTo.some(({ id: id2 }) => id2 === id1)
          );
          let treatmentRightCC = data.filter(
            ({ id: id1 }) => !treatmentLeftCC.some(({ id: id2 }) => id2 === id1)
          );
          preliminaryRightTo = preliminaryRightTo.filter(({ id: id1 }) =>
            preliminaryRightCC.some(({ id: id2 }) => id2 === id1)
          );
          preliminaryRightCC = preliminaryRightCC.filter(({ id: id1 }) =>
            preliminaryRightTo.some(({ id: id2 }) => id2 === id1)
          );
          treatmentRightTo = treatmentRightTo.filter(({ id: id1 }) =>
            treatmentRightCC.some(({ id: id2 }) => id2 === id1)
          );
          treatmentRightCC = treatmentRightCC.filter(({ id: id1 }) =>
            treatmentRightTo.some(({ id: id2 }) => id2 === id1)
          );
          this.setState({
            // CountryData: res.data.allCountries.Countries,
            Userdata: res.data.allUserdata.Userdata,
            preliminaryRightTo,
            preliminaryRightCC,
            treatmentRightTo,
            treatmentRightCC,
            loading: false,
          });
        }
      })
      .catch((e) => {
        this.setState({ loading: false });
        console.log(e);
      });
  }
  Sites = () => {
    this.props.history.push("/sites");
  };
  handleDelete = (value) => {
    const test = {
      id: value.siteemail,
      active: 0,
    };

    mutationQueries(siteEmailQuery, { obj: test })
      .then((res) => {
        return res;
      })
      .catch((e) => console.log(e));
  };
  /****************Preliminary Analysis Email Rules To***********************/
  notPreliminaryTo = (a, b) => {
    return a.filter((value) => b.indexOf(value) === -1);
  };

  intersectionPreliminaryTo = (a, b) => {
    return a.filter((value) => b.indexOf(value) !== -1);
  };

  handleTogglePreliminaryRightTo = (value) => () => {
    const { checkedPreliminaryRightTo } = this.state;
    let currentIndex = checkedPreliminaryRightTo.indexOf(value);
    let newChecked = [...checkedPreliminaryRightTo];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }
    this.setState({ checkedPreliminaryRightTo: newChecked });
  };

  handleCheckedPreliminaryLeftTo = () => {
    this.setState({
      preliminaryLeftTo: this.state.preliminaryLeftTo.concat(
        this.intersectionPreliminaryTo(
          this.state.checkedPreliminaryRightTo,
          this.state.preliminaryRightTo
        )
      ),
    });
    this.setState({
      preliminaryRightTo: this.notPreliminaryTo(
        this.state.preliminaryRightTo,
        this.intersectionPreliminaryTo(
          this.state.checkedPreliminaryRightTo,
          this.state.preliminaryRightTo
        )
      ),
      preliminaryRightCC: this.notPreliminaryTo(
        this.state.preliminaryRightCC,
        this.intersectionPreliminaryTo(
          this.state.checkedPreliminaryRightTo,
          this.state.preliminaryRightCC
        )
      ),
    });
    this.setState({
      checkedPreliminaryRightTo: this.notPreliminaryTo(
        this.state.checkedPreliminaryRightTo,
        this.intersectionPreliminaryTo(
          this.state.checkedPreliminaryRightTo,
          this.state.preliminaryRightTo
        )
      ),
    });
  };
  MovePreliminaryRightTo = (value, index) => {
    const {
      preliminaryLeftTo,
      preliminaryRightTo,
      preliminaryRightCC,
    } = this.state;
    if (value.siteemail) {
      this.handleDelete(value);
    }
    delete value.siteemail;
    preliminaryLeftTo.splice(index, 1);
    preliminaryRightTo.push(value);
    preliminaryRightCC.push(value);
    this.setState({
      preliminaryLeftTo,
      preliminaryRightTo,
      preliminaryRightCC,
    });
  };
  PreliminaryListLeftTo = (title, items) => (
    <Card>
      <List dense component="div" role="list">
        {items.map((value, index) => {
          return (
            <Chip
              key={index}
              id={value.id}
              label={`${value.firstname} ${
                value.lastname ? value.lastname : ""
              }`}
              onDelete={() => this.MovePreliminaryRightTo(value, index)}
            />
          );
        })}
        <ListItem />
      </List>
    </Card>
  );
  PreliminaryListRightTo = (title, items) => (
    <Card>
      <List dense component="div" role="list">
        {items.map((value) => {
          return (
            <ListItem
              key={value.id}
              role="listitem"
              button
              onClick={this.handleTogglePreliminaryRightTo(value)}
            >
              <Checkbox
                checked={
                  this.state.checkedPreliminaryRightTo.indexOf(value) !== -1
                }
                tabIndex={-1}
                disableRipple
                inputProps={{ "aria-labelledby": value.id }}
              />
              <ListItemText
                id={value.id}
                primary={`${value.firstname} ${
                  value.lastname ? value.lastname : ""
                }`}
              />
            </ListItem>
          );
        })}
        <ListItem />
      </List>
    </Card>
  );
  /************************************************************************/

  /****************Preliminary Analysis Email Rules CC***********************/
  notPreliminaryCC = (a, b) => {
    return a.filter((value) => b.indexOf(value) === -1);
  };

  intersectionPreliminaryCC = (a, b) => {
    return a.filter((value) => b.indexOf(value) !== -1);
  };
  handleTogglePreliminaryRightCC = (value) => () => {
    const { checkedPreliminaryRightCC } = this.state;
    let currentIndex = checkedPreliminaryRightCC.indexOf(value);
    let newChecked = [...checkedPreliminaryRightCC];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }
    this.setState({ checkedPreliminaryRightCC: newChecked });
  };
  handleCheckedPreliminaryLeftCC = () => {
    this.setState({
      preliminaryLeftCC: this.state.preliminaryLeftCC.concat(
        this.intersectionPreliminaryCC(
          this.state.checkedPreliminaryRightCC,
          this.state.preliminaryRightCC
        )
      ),
    });
    this.setState({
      preliminaryRightCC: this.notPreliminaryCC(
        this.state.preliminaryRightCC,
        this.intersectionPreliminaryCC(
          this.state.checkedPreliminaryRightCC,
          this.state.preliminaryRightCC
        )
      ),
      preliminaryRightTo: this.notPreliminaryCC(
        this.state.preliminaryRightTo,
        this.intersectionPreliminaryCC(
          this.state.checkedPreliminaryRightCC,
          this.state.preliminaryRightTo
        )
      ),
    });
    this.setState({
      checkedPreliminaryRightCC: this.notPreliminaryCC(
        this.state.checkedPreliminaryRightCC,
        this.intersectionPreliminaryCC(
          this.state.checkedPreliminaryRightCC,
          this.state.preliminaryRightCC
        )
      ),
    });
  };
  MovePreliminaryRightCC = (value, index) => {
    const {
      preliminaryLeftCC,
      preliminaryRightCC,
      preliminaryRightTo,
    } = this.state;
    if (value.siteemail) {
      this.handleDelete(value);
    }
    delete value.siteemail;
    preliminaryLeftCC.splice(index, 1);
    preliminaryRightCC.push(value);
    preliminaryRightTo.push(value);
    this.setState({
      preliminaryLeftCC,
      preliminaryRightCC,
      preliminaryRightTo,
    });
  };
  PreliminaryListLeftCC = (title, items) => (
    <Card>
      <List dense component="div" role="list">
        {items.map((value, index) => {
          return (
            <Chip
              key={index}
              id={value.id}
              label={`${value.firstname} ${
                value.lastname ? value.lastname : ""
              }`}
              onDelete={() => this.MovePreliminaryRightCC(value, index)}
            />
          );
        })}
        <ListItem />
      </List>
    </Card>
  );
  PreliminaryListRightCC = (title, items) => (
    <Card>
      <List dense component="div" role="list">
        {items.map((value) => {
          return (
            <ListItem
              key={value.id}
              role="listitem"
              button
              onClick={this.handleTogglePreliminaryRightCC(value)}
            >
              <Checkbox
                checked={
                  this.state.checkedPreliminaryRightCC.indexOf(value) !== -1
                }
                tabIndex={-1}
                disableRipple
                inputProps={{ "aria-labelledby": value.id }}
              />
              <ListItemText
                id={value.id}
                primary={`${value.firstname} ${
                  value.lastname ? value.lastname : ""
                }`}
              />
            </ListItem>
          );
        })}
        <ListItem />
      </List>
    </Card>
  );
  /*************************************************************************/
  /************** Treatment Plan Email Rules To *****************************/
  notTreatmentTo = (a, b) => {
    return a.filter((value) => b.indexOf(value) === -1);
  };

  intersectionTreatmentTo = (a, b) => {
    return a.filter((value) => b.indexOf(value) !== -1);
  };
  handleToggleTreatmentRightTo = (value) => () => {
    const { checkedTreatmentRightTo } = this.state;
    let currentIndex = checkedTreatmentRightTo.indexOf(value);
    let newChecked = [...checkedTreatmentRightTo];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }
    this.setState({ checkedTreatmentRightTo: newChecked });
  };
  handleCheckedTreatmentLeftTo = () => {
    this.setState({
      treatmentLeftTo: this.state.treatmentLeftTo.concat(
        this.intersectionTreatmentTo(
          this.state.checkedTreatmentRightTo,
          this.state.treatmentRightTo
        )
      ),
    });
    this.setState({
      treatmentRightTo: this.notTreatmentTo(
        this.state.treatmentRightTo,
        this.intersectionTreatmentTo(
          this.state.checkedTreatmentRightTo,
          this.state.treatmentRightTo
        )
      ),
      treatmentRightCC: this.notTreatmentTo(
        this.state.treatmentRightCC,
        this.intersectionTreatmentTo(
          this.state.checkedTreatmentRightTo,
          this.state.treatmentRightCC
        )
      ),
    });
    this.setState({
      checkedTreatmentRightTo: this.notTreatmentTo(
        this.state.checkedTreatmentRightTo,
        this.intersectionTreatmentTo(
          this.state.checkedTreatmentRightTo,
          this.state.treatmentRightTo
        )
      ),
    });
  };
  MoveTreatmentRightTo = (value, index) => {
    const { treatmentLeftTo, treatmentRightTo, treatmentRightCC } = this.state;
    if (value.siteemail) {
      this.handleDelete(value);
    }
    delete value.siteemail;
    treatmentLeftTo.splice(index, 1);
    treatmentRightTo.push(value);
    treatmentRightCC.push(value);
    this.setState({ treatmentLeftTo, treatmentRightTo, treatmentRightCC });
  };
  TreatmentListLeftTo = (title, items) => (
    <Card>
      <List dense component="div" role="list">
        {items.map((value, index) => {
          return (
            <Chip
              key={index}
              id={value.id}
              label={`${value.firstname} ${
                value.lastname ? value.lastname : ""
              }`}
              onDelete={() => this.MoveTreatmentRightTo(value, index)}
            />
          );
        })}
        <ListItem />
      </List>
    </Card>
  );
  TreatmentListRightTo = (title, items) => (
    <Card>
      <List dense component="div" role="list">
        {items.map((value) => {
          return (
            <ListItem
              key={value.id}
              role="listitem"
              button
              onClick={this.handleToggleTreatmentRightTo(value)}
            >
              <Checkbox
                checked={
                  this.state.checkedTreatmentRightTo.indexOf(value) !== -1
                }
                tabIndex={-1}
                disableRipple
                inputProps={{ "aria-labelledby": value.id }}
              />
              <ListItemText
                id={value.id}
                primary={`${value.firstname} ${
                  value.lastname ? value.lastname : ""
                }`}
              />
            </ListItem>
          );
        })}
        <ListItem />
      </List>
    </Card>
  );
  /*************************************************************************/
  /****************************Treatment Plan Email Rules CC**************************************/
  notTreatmentCC = (a, b) => {
    return a.filter((value) => b.indexOf(value) === -1);
  };

  intersectionTreatmentCC = (a, b) => {
    return a.filter((value) => b.indexOf(value) !== -1);
  };
  handleToggleTreatmentRightCC = (value) => () => {
    const { checkedTreatmentRightCC } = this.state;
    let currentIndex = checkedTreatmentRightCC.indexOf(value);
    let newChecked = [...checkedTreatmentRightCC];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }
    this.setState({ checkedTreatmentRightCC: newChecked });
  };
  handleCheckedTreatmentLeftCC = () => {
    this.setState({
      treatmentLeftCC: this.state.treatmentLeftCC.concat(
        this.intersectionTreatmentCC(
          this.state.checkedTreatmentRightCC,
          this.state.treatmentRightCC
        )
      ),
    });
    this.setState({
      treatmentRightCC: this.notTreatmentCC(
        this.state.treatmentRightCC,
        this.intersectionTreatmentCC(
          this.state.checkedTreatmentRightCC,
          this.state.treatmentRightCC
        )
      ),
      treatmentRightTo: this.notTreatmentCC(
        this.state.treatmentRightTo,
        this.intersectionTreatmentCC(
          this.state.checkedTreatmentRightCC,
          this.state.treatmentRightTo
        )
      ),
    });
    this.setState({
      checkedTreatmentRightCC: this.notTreatmentCC(
        this.state.checkedTreatmentRightCC,
        this.intersectionTreatmentCC(
          this.state.checkedTreatmentRightCC,
          this.state.treatmentRightCC
        )
      ),
    });
  };
  MoveTreatmentRightCC = (value, index) => {
    const { treatmentLeftCC, treatmentRightCC, treatmentRightTo } = this.state;
    if (value.siteemail) {
      this.handleDelete(value);
    }
    delete value.siteemail;
    treatmentLeftCC.splice(index, 1);
    treatmentRightCC.push(value);
    treatmentRightTo.push(value);
    this.setState({ treatmentLeftCC, treatmentRightCC, treatmentRightTo });
  };
  TreatmentListLeftCC = (title, items) => (
    <Card>
      <List dense component="div" role="list">
        {items.map((value, index) => {
          return (
            <Chip
              key={index}
              id={value.id}
              label={`${value.firstname} ${
                value.lastname ? value.lastname : ""
              }`}
              onDelete={() => this.MoveTreatmentRightCC(value, index)}
            />
          );
        })}
        <ListItem />
      </List>
    </Card>
  );
  TreatmentListRightCC = (title, items) => (
    <Card>
      <List dense component="div" role="list">
        {items.map((value) => {
          return (
            <ListItem
              key={value.id}
              role="listitem"
              button
              onClick={this.handleToggleTreatmentRightCC(value)}
            >
              <Checkbox
                checked={
                  this.state.checkedTreatmentRightCC.indexOf(value) !== -1
                }
                tabIndex={-1}
                disableRipple
                inputProps={{ "aria-labelledby": value.id }}
              />
              <ListItemText
                id={value.id}
                primary={`${value.firstname} ${
                  value.lastname ? value.lastname : ""
                }`}
              />
            </ListItem>
          );
        })}
        <ListItem />
      </List>
    </Card>
  );
  /************************************************************************/

  EmailSection = () => {
    let {
      preliminaryLeftTo,
      preliminaryRightTo,
      preliminaryLeftCC,
      preliminaryRightCC,
      treatmentLeftTo,
      treatmentRightTo,
      treatmentLeftCC,
      treatmentRightCC,
    } = this.state;
    return (
      <div className="analysisEmail">
        <div className="preliminaryAnalysis">
          <h5>Preliminary Analysis Email Rules</h5>
          {/****************Preliminary Analysis Email Rules To***********************/}
          <Grid container spacing={2} justify="center" alignItems="center">
            <span>To:</span>
            <Grid item>
              {this.PreliminaryListLeftTo("Choices", preliminaryLeftTo)}
            </Grid>
            <Grid item>
              <Grid container direction="column" alignItems="center">
                <IconButton
                  variant="outlined"
                  size="small"
                  onClick={this.handleCheckedPreliminaryLeftTo}
                >
                  <ArrowBackIosIcon />
                </IconButton>
              </Grid>
            </Grid>
            <Grid item>
              {this.PreliminaryListRightTo("Chosen", preliminaryRightTo)}
            </Grid>
          </Grid>
          {/**************************************************************/}
          {/****************Preliminary Analysis Email Rules CC***********************/}
          <Grid container spacing={2} justify="center" alignItems="center">
            <span>CC:</span>
            <Grid item>
              {this.PreliminaryListLeftCC("Choices", preliminaryLeftCC)}
            </Grid>
            <Grid item>
              <Grid container direction="column" alignItems="center">
                <IconButton
                  variant="outlined"
                  size="small"
                  onClick={this.handleCheckedPreliminaryLeftCC}
                >
                  <ArrowBackIosIcon />
                </IconButton>
              </Grid>
            </Grid>
            <Grid item>
              {this.PreliminaryListRightCC("Chosen", preliminaryRightCC)}
            </Grid>
          </Grid>
          {/**************************************************************************/}
        </div>
        <div className="treatmentPlan">
          <h5>Treatment Plan Email Rules</h5>
          {/****************Treatment Plan Email Rules To***********************/}
          <Grid container spacing={2} justify="center" alignItems="center">
            <span>To:</span>
            <Grid item>
              {this.TreatmentListLeftTo("Choices", treatmentLeftTo)}
            </Grid>
            <Grid item>
              <Grid container direction="column" alignItems="center">
                <IconButton
                  variant="outlined"
                  size="small"
                  onClick={this.handleCheckedTreatmentLeftTo}
                >
                  <ArrowBackIosIcon />
                </IconButton>
              </Grid>
            </Grid>
            <Grid item>
              {this.TreatmentListRightTo("Chosen", treatmentRightTo)}
            </Grid>
          </Grid>
          {/**************************************************************/}
          {/****************Treatment Plan Email Rules CC***********************/}
          <Grid container spacing={2} justify="center" alignItems="center">
            <span>CC:</span>
            <Grid item>
              {this.TreatmentListLeftCC("Choices", treatmentLeftCC)}
            </Grid>
            <Grid item>
              <Grid container direction="column" alignItems="center">
                <IconButton
                  variant="outlined"
                  size="small"
                  onClick={this.handleCheckedTreatmentLeftCC}
                >
                  <ArrowBackIosIcon />
                </IconButton>
              </Grid>
            </Grid>
            <Grid item>
              {this.TreatmentListRightCC("Chosen", treatmentRightCC)}
            </Grid>
          </Grid>
          {/**************************************************************************/}
        </div>
      </div>
    );
  };
  preSubmitChanges = (e) => {
    this.setState({ loading: true, saveButtonDisabled: true });
    e.active = 1;
    e.countryid = e.countryid ? e.countryid.id : null;
    e.cityid = e.cityid ? e.cityid.id : null;
    e.stateid = e.stateid ? e.stateid.id : null;
    delete e.sitecityrel;
    delete e.sitecountryrel;
    delete e.sitestaterel;
    delete e.PaSiteMap;
    mutationQueries(addSiteQuery, { obj: e })
      .then((res) => {
        let id = res.data.saveSite.id;
        this.setState({ loading: false });
        if (id) {
          this.saveUsersList(id);
          this.setState(
            {
              open: true,
              severity: "success",
              alertmsg: "Record Updated Successfully!",
            },
            () => {
              setTimeout(() => {
                this.props.history.push("/sites");
              }, 2000);
            }
          );
        }
      })
      .catch((e) => {
        this.setState({ loading: false, saveButtonDisabled: false });
        this.setState({
          open: true,
          severity: "error",
          alertmsg: e.message.toString().split(":")[2],
        });
      });
    return true;
  };
  saveUsersList = (id) => {
    let {
      preliminaryLeftTo,
      preliminaryLeftCC,
      treatmentLeftTo,
      treatmentLeftCC,
    } = this.state;
    let query = "";
    let query1 = "";
    let query2 = "";
    let query3 = "";
    preliminaryLeftTo.map((item, index) => {
      return (query += `id${index}: saveSiteemails(
              obj: {
                id:${item.siteemail ? item.siteemail : null},
               type:"PA",
               toorcc:"TO",
               siteid:${id},
               userid:${item.id}
              }
            ){id}`);
    });
    preliminaryLeftCC.map((item, index) => {
      return (query1 += `id${index}: saveSiteemails(
              obj: {
                id:${item.siteemail ? item.siteemail : null},
               type:"PA",
               toorcc:"CC",
               siteid:${id},
               userid:${item.id}
              }
            ){id}`);
    });
    treatmentLeftTo.map((item, index) => {
      return (query2 += `id${index}: saveSiteemails(
              obj: {
                id:${item.siteemail ? item.siteemail : null},
               type:"TREATMENT",
               toorcc:"TO",
               siteid:${id},
               userid:${item.id}
              }
            ){id}`);
    });
    treatmentLeftCC.map((item, index) => {
      return (query3 += `id${index}: saveSiteemails(
              obj: {
                id:${item.siteemail ? item.siteemail : null},
               type:"TREATMENT",
               toorcc:"CC",
               siteid:${id},
               userid:${item.id}
              }
            ){id}`);
    });
    if (query !== "") {
      mutationQueries(gql`mutation{${query}}`)
        .then((res) => {
          return res;
        })
        .catch((e) => console.log(e));
    }
    if (query1 !== "") {
      mutationQueries(gql`mutation{${query1}}`)
        .then((res) => {
          return res;
        })
        .catch((e) => console.log(e));
    }
    if (query2 !== "") {
      mutationQueries(gql`mutation{${query2}}`)
        .then((res) => {
          return res;
        })
        .catch((e) => console.log(e));
    }
    if (query3 !== "") {
      mutationQueries(gql`mutation{${query3}}`)
        .then((res) => {
          return res;
        })
        .catch((e) => console.log(e));
    }
  };
  handleSnackBarClose = () => {
    let { severity } = this.state;
    this.setState({ open: false, severity: "", alertmsg: "" });
    if (severity === "success") {
      this.props.history.push("/sites");
    }
  };

  siteCountryData = (value) => {
    if (value.length > 1) {
      this.setState({ CountryData: [], StateData: [] });
      this.debounceTimer = debounce(
        this.debounceTimer,
        () =>
          fetchMethod(siteCountry, {
            where: { name: { like: `%${value}%` } },
          })
            .then((res) => res.json())
            .then((res) => {
              this.setState(
                { CountryData: res.data.allCountries.Countries },
                () => {
                  return this.state.CountryData;
                }
              );
            })
            .catch((e) => console.log(e)),
        200
      );
    } else {
      this.setState({ CountryData: [], StateData: [] });
    }
  };
  siteStateData = (value, id) => {
    if (value.length > 1) {
      this.setState({ StateData: [], CityData: [] });
      this.debounceTimer = debounce(
        this.debounceTimer,
        () =>
          fetchMethod(siteStateData, {
            where: {
              name: {
                like: `%${value}%`,
              },
              countryid: id,
              active: 1,
              order: "name asc",
            },
          })
            .then((res) => res.json())
            .then((res) => {
              this.setState({ StateData: res.data.allStates.States }, () => {
                return this.state.StateData;
              });
            })
            .catch((e) => console.log(e)),
        200
      );
    } else {
      this.setState({ StateData: [], CityData: [] });
    }
  };
  siteCityData = (value, id) => {
    if (value.length > 1) {
      this.setState({ CityData: [] });
      this.debounceTimer = debounce(
        this.debounceTimer,
        () =>
          fetchMethod(siteCityData, {
            where: {
              name: {
                like: `%${value}%`,
              },
              stateid: id,
              active: 1,
              order: "name asc",
            },
          })
            .then((res) => res.json())
            .then((res) => {
              this.setState({ CityData: res.data.allCities.Cities }, () => {
                return this.state.CityData;
              });
            })
            .catch((e) => console.log(e)),
        200
      );
    } else {
      this.setState({ CityData: [] });
    }
  };
  render() {
    return (
      <div className="addsiteSection">
        {this.state.loading ? (
          <div className="Loader">
            <FadeLoader
              style={{ height: "15", width: "5", radius: "2" }}
              color={"#6FABF0"}
              loading={this.state.loading}
            />
          </div>
        ) : (
          ""
        )}
        {this.state.open ? (
          <SnackBarComponent
            severity={this.state.severity}
            open={this.state.open}
            alertmsg={this.state.alertmsg}
            handleClose={this.handleSnackBarClose}
            className="addUserSnackBar"
          />
        ) : (
          ""
        )}
        <ul className="sitepath">
          <li onClick={this.Sites} style={{ cursor: "pointer" }}>
            Sites
          </li>
          <li>
            <span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="13.992"
                height="8"
                viewBox="0 0 13.992 8"
              >
                <defs></defs>
                <path
                  className="a"
                  d="M13.186,16.835l5.291-5.295a1,1,0,0,1,1.412,0,1.008,1.008,0,0,1,0,1.416l-5.995,6a1,1,0,0,1-1.379.029L6.479,12.961a1,1,0,0,1,1.412-1.416Z"
                  transform="translate(-6.188 -11.246)"
                />
              </svg>
            </span>
          </li>
          <li> Edit Site</li>
        </ul>
        <h2>Edit Site</h2>
        {this.state.editableData && this.state.CountryData ? (
          <FormComponent
            formConfig={addSite}
            preSubmitChanges={this.preSubmitChanges}
            query={addSiteQuery}
            showContentOnForm={{ Email: this.EmailSection }}
            independentSearch={{ siteconfig: this.siteCountryData }}
            editableData={this.state.editableData}
            params={{
              countryOptions: this.state.CountryData,
              stateOptions: this.state.StateData,
              cityOptions: this.state.CityData,
            }}
            dependentSearch={{
              statedata: this.siteStateData,
              citydata: this.siteCityData,
            }}
            saveButtonDisabled={this.state.saveButtonDisabled}
          />
        ) : (
          ""
        )}
      </div>
    );
  }
}

export default EditSiteForm;
